export const HIGHLIGHT = '/beneficios?tab=featured';
export const COUPONS = '/beneficios?tab=coupons';
export const BENEFITS = '/beneficios';

export const LOGIN_URL = '/login?ref=landing-consolidadora&redirect_to=https://www.decolar.com/account-linker/ifood/landing?source=login';

const IFOOD_PAGE_URL = 'https://disrupt.ifood.com.br/despegar/account/connect?source=landing_decolar&campaign=close_loop_discount&clt=travel_category';
export const IFOOD_URL = `ifood://webmiddleware?isImmersive=false&isModal=false&isFullscreen=false&hideTopSafeArea=true&page=${encodeURIComponent(IFOOD_PAGE_URL)}`;

export const VIEW_ALL_COUPONS = '/ofertas-viagens/cupons';
export const COUPON_URLS = {
  DECOLAIFOOD: '/ofertas-viagens/cupons_hotel',
  HOTEL15IFOOD: '/ofertas-viagens/cupons_hotel',
  PACOTES10IFOOD: '/ofertas-viagens/cupons_pacotes',
} as Record<string, string>;

export const CLUB_URL = '/account-linker/ifood/club-subscriber-checker';
export const CLUBE_HOTELS = '/ofertas-viagens/hoteisclubeifood';
export const CLUBE_ASSISTANCE = '/ofertas-viagens/seguroviagemclubeifood';
export const CLUBE_CARS = '/ofertas-viagens/carrosclubeifood';
export const CLUBE_WANT_MEMBER = 'https://ifoodbr.onelink.me/F4X4/clubexternaldecolar';

export const SHARE_WITH_FRIENDS_URL = 'https://www.decolar.com/account-linker/ifood/landing?source=compartido';
